<template>
  <div class="container" id="speaker-container">
    <h2 class="text-center text-grey-dark">Palestrantes</h2>
    <div v-if="load" class="text-center text-secondary mt-5 mb-3">
      <i class="fas fa-3x fa-spinner fa-pulse"></i>
      <br />
      <span v-if="$route.params.language === 'pt'">Carregando ...</span>
      <span v-if="$route.params.language === 'en'">Loading...</span>
      <span v-if="$route.params.language === 'es'">Carregando...</span>
    </div>
    <div v-else class="speaker-stage">
      <div
        v-for="speaker in speakers"
        :key="speaker.id"
        v-if="
          hasRoom(speaker, 17) ||
          hasRoom(speaker, 18) ||
          hasRoom(speaker, 19) ||
          hasRoom(speaker, 20) ||
          hasRoom(speaker, 21) ||
          hasRoom(speaker, 22) ||
          hasRoom(speaker, 23) ||
          hasRoom(speaker, 24) ||
          hasRoom(speaker, 25)"
        class="speaker-card px-3 py-3 hover:shadow-lg hover:animate hover:bounce"
      >
        <div class="flex items-center">
          <div class="w-1/3">
            <div class="speaker-avatar">
              <img
                v-if="speaker.photo"
                :src="`https://px3-static.sfo2.cdn.digitaloceanspaces.com/futurecom19/${speaker.photo}`"
                alt
              />
              <img v-else src="https://cdn4.iconfinder.com/data/icons/mayssam/512/user-512.png" alt />
            </div>
          </div>
          <div
            class="w-2/3 flex flex-col content-between speaker-info mt-4 sm:mt-0 sm:ml-4 text-center sm:text-left block"
          >
            <h4 class="text-xl leading-tight">{{ speaker.name }}</h4>
            <p
              class="text-sm leading-tight text-gray-600"
            >{{ speaker.job_title_pt }} @ {{ speaker.company ? speaker.company.company_pt : null }}</p>
            <div class="mt-3">
              <button
                type="button"
                class="text-blue-500 hover:text-white hover:bg-blue-500 border border-blue-500 text-xs font-semibold rounded-full px-4 py-1 leading-normal"
                data-toggle="modal"
                :data-target="`#modal-${speaker.id}`"
              >+ Informações</button>
            </div>
          </div>
        </div>
        <!-- Logos dos congressos -->
        <div class="flex justify-center mt-2">
          <img
            v-if="
              hasRoom(speaker, 2) ||
              hasRoom(speaker, 4) ||
              hasRoom(speaker, 5) ||
              hasRoom(speaker, 6) ||
              hasRoom(speaker, 3) ||
              hasRoom(speaker, 7)"
            src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/congress.png"
            alt
            width="50px"
            class="mx-2"
          />
          <img
            v-if="hasRoom(speaker, 9)"
            src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/gov.png"
            alt
            width="50px"
            class="mx-2"
          />
          <img
            v-if="hasRoom(speaker, 8)"
            src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/jud.png"
            alt
            width="50px"
            class="mx-2"
          />
          <img
            v-if="hasRoom(speaker, 1) || hasRoom(speaker, 13)"
            src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/payment.png"
            alt
            width="50px"
            class="mx-2"
          />
          <img
            v-if="hasRoom(speaker, 12)"
            src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/tech.png"
            alt
            width="50px"
            class="mx-2"
          />
        </div>
        <!-- Logos dos congressos -->

        <!-- Modal -->
        <div
          class="modal fade"
          :id="`modal-${speaker.id}`"
          tabindex="-1"
          role="dialog"
          :aria-labelledby="`${speaker.id}modalLabel`"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5
                  class="modal-title"
                  :id="`${speaker.id}modalLabel`"
                >Informações - {{ speaker.name }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="flex items-center">
                  <div class="w-1/3">
                    <div v-if="speaker.photo" class="speaker-info-avatar">
                      <img
                        :src="`https://px3-static.sfo2.cdn.digitaloceanspaces.com/futurecom19/${speaker.photo}`"
                        :alt="speaker.name"
                      />
                    </div>
                  </div>
                  <div
                    class="w-2/3 flex flex-col content-between speaker-info mt-4 sm:mt-0 sm:ml-4 text-center sm:text-left"
                  >
                    <h4 class="text-xl leading-tight">{{ speaker.name }}</h4>
                    <p class="text-sm leading-tight text-gray-600">
                      <span class="mb-2">{{ speaker.job_title_pt }}</span>
                      <br />
                      <span v-if="speaker.company">
                        <img
                          v-if="speaker.company.logo"
                          class="my-2"
                          style="margin: 0 auto; width: 100px"
                          :src="`https://px3-static.sfo2.cdn.digitaloceanspaces.com/futurecom19/${speaker.company.logo}`"
                          :alt="speaker.company.logo"
                        />
                        <span v-else>{{ speaker.company.company_pt }}</span>
                      </span>
                    </p>
                  </div>
                </div>
                <hr />
                <div v-if="speaker.curriculum_pt">
                  <p class="leading-tight text-gray-700">Curriculo</p>
                  <p class="text-sm text-gray-600">{{ speaker.curriculum_pt }}</p>
                </div>
                <div>
                  <span v-for="slot in speaker.slots_keynote" :key="speaker.id+slot.id">
                    <p
                      v-if="slot.grid"
                      class="text-sm text-gray-600 p-1 mt-2 border border-blue-300 rounded"
                    >
                      {{ slot.title }}
                      <br />
                      <span class="text-gray-700 text-sm italic">
                        {{ slot.grid.start_time | formatDay }} |
                        {{ slot.grid.start_time | formatDate }} -
                        {{ slot.grid.end_time | formatDate }}
                        <br />
                        {{ slot.grid.room.name_pt }}
                      </span>
                    </p>
                  </span>
                </div>
                <!-- Logo dos congressos -->
                <div class="flex justify-center mt-2">
                  <img
                    v-if="
                      hasRoom(speaker, 2) ||
                      hasRoom(speaker, 4) ||
                      hasRoom(speaker, 5) ||
                      hasRoom(speaker, 6) ||
                      hasRoom(speaker, 3) ||
                      hasRoom(speaker, 7)"
                    src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/congress.png"
                    alt
                    width="100px"
                    class="mx-2"
                  />
                  <img
                    v-if="hasRoom(speaker, 9)"
                    src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/gov.png"
                    alt
                    width="100px"
                    class="mx-2"
                  />
                  <img
                    v-if="hasRoom(speaker, 8)"
                    src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/jud.png"
                    alt
                    width="100px"
                    class="mx-2"
                  />
                  <img
                    v-if="hasRoom(speaker, 1) || hasRoom(speaker, 13)"
                    src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/payment.png"
                    alt
                    width="100px"
                    class="mx-2"
                  />
                  <img
                    v-if="hasRoom(speaker, 12)"
                    src="https://px3-static.sfo2.cdn.digitaloceanspaces.com/palestra/futurecom2019/congress/congress/tech.png"
                    alt
                    width="100px"
                    class="mx-2"
                  />
                </div>
                <!-- Logo dos congressos -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { HTTP } from "../axios";
export default {
  name: "Keynotes",
  data() {
    return {
      speakers: {},
      load: true,
      speakerSelected: {}
    };
  },
  methods: {
    getSpeakers() {
      HTTP.get("event-speakers/85128089-0970-44fe-81d3-f902376b1651").then(
        response => {
          this.speakers = response.data;
          this.load = false;
        }
      );
    },
    hasRoom(speaker, room) {
      if (speaker.slots_keynote.length > 0) {
        for (let index = 0; index < speaker.slots_keynote.length; index++) {
          const element = speaker.slots_keynote[index];
          if (element.grid) {
            if (element.grid.room_id === room) {
              return true;
            }
          }
        }
      }

      if (speaker.slots_coordinators.length > 0) {
        for (
          let index = 0;
          index < speaker.slots_coordinators.length;
          index++
        ) {
          const element2 = speaker.slots_coordinators[index];
          if (element2.grid) {
            if (element2.grid.room_id === room) {
              return true;
            }
          }
        }
      }

      if (speaker.slots_mediators.length > 0) {
        for (let index = 0; index < speaker.slots_mediators.length; index++) {
          const element3 = speaker.slots_mediators[index];
          if (element3.grid) {
            if (element3.grid.room_id === room) {
              return true;
            }
          }
        }
      }

      if (speaker.slots_panelists.length > 0) {
        for (let index = 0; index < speaker.slots_panelists.length; index++) {
          const element4 = speaker.slots_panelists[index];
          if (element4.grid) {
            if (element4.grid.room_id === room) {
              return true;
            }
          }
        }
      }

      return false;
    }
  },
  mounted() {
    this.getSpeakers();
  }
};
</script>

<style>
@import "https://unpkg.com/tailwindcss@^1.0/dist/tailwind.min.css";
.speaker-stage {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.speaker-card {
  flex-grow: 1;
  margin: 8px;
  background: rgb(246, 246, 246);
  background: -moz-linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(246, 246, 246, 1) 52%
  );
  background: -webkit-linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(246, 246, 246, 1) 52%
  );
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(246, 246, 246, 1) 52%
  );
  filter: progid: DXImageTransform.Microsoft.gradient(startColorstr="#f6f6f6",endColorstr="#ffffff",GradientType=1);
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  width: 300px;
}
.speaker-avatar {
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 120px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  margin: 0 auto;
}
.speaker-avatar img {
  width: 95px;
  height: auto;
  margin: 0 auto;
}

.speaker-info-avatar {
  width: 120px;
  height: 120px;
  overflow: hidden;
  border-radius: 5px;
  margin: 0 auto;
}
.speaker-info-avatar img {
  width: 150px;
  height: auto;
  margin: 0 auto;
}

.agenda-title {
  font-size: 2.5rem;
}
</style>





// WEBPACK FOOTER //
// src/components/Keynotes.vue